import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { ProOnly } from '../label/ProOnly';

import { Icon } from '@iconify/react';
import checkboxBlankOutline from '@iconify/icons-mdi/checkbox-blank-outline';
import checkboxMarked from '@iconify/icons-mdi/checkbox-marked';

/**
 * @param {string} id
 * @param {string} name
 * @param   {bool} checked
 * @param {string} label
 * @param {string} description
 */
const StyledNekoCheckbox = Styled(props => {
  const { id, name, checked = false, label, description, isPro, requirePro = false } = props;
  const [isChecked, check] = React.useState(checked);

  const showUpProOnly = requirePro && !isPro;
  const disabledClass = showUpProOnly ? 'disabled' : '';

  function onClick(ev) {
    check(!isChecked); // Toggle
  }
  return (
    <div className={['nui-checkbox', props.className, disabledClass].join(' ')}>
      <input id={id} name={name} type="checkbox" defaultChecked={isChecked} onClick={onClick} disabled={showUpProOnly} />
      <label htmlFor={id}>
      <Icon icon={isChecked ? checkboxMarked : checkboxBlankOutline} width="30px" color={showUpProOnly ? Theme.disabledForm : Theme.blue} />
      <div className="inner-container">
        <span className="label">{label}<ProOnly className="inline" show={showUpProOnly} /></span>
        {description ? <small className="description">{description}</small> : null}
      </div>
      </label>
    </div>
  );
})`
  font-family: Lato, sans-serif;

  &.disabled {
    color: ${Theme.disabledForm};

    label {
      cursor: default;
    }
  }

  input {
    display: none;
  }

  label {
    cursor: pointer;
    display: flex;
  }
  .inner-container {
    margin-top: 1.5px;
    margin-left: 4px;

    .label {
      display: block;
      font-size: 14px;
      line-height: 17px;
      padding-top: 4.5px;
      padding-bottom: 4px;
    }
    .description {
      display: block;
      font-size: 12px;
    }
  }
`;

const NekoCheckbox = (props) => {
  return (<StyledNekoCheckbox {...props} />);
}

NekoCheckbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
  description: PropTypes.string,
  isPro: PropTypes.bool,
  requirePro: PropTypes.bool
};

NekoCheckbox.defaultProps = {
  id: undefined,
  name: undefined,
  checked: false,
  label: undefined,
  description: undefined,
  isPro: false,
  requirePro: false
};

export { NekoCheckbox };
